import React from 'react'
import clsx from 'clsx'

const Tag = ({
  as: Component = 'div',
  className,
  children,
  variant = 'blue',
}) => {
  const styles = clsx(
    `text-base inline-block rounded-full px-5 py-1 uppercase font-bold font-muli`,
    variant === 'blue' && `bg-blue-100 text-white`,
    variant === 'purple' && `bg-purple-500 text-white`,
    variant === 'orange' && `bg-yellow-400 text-white`,
    variant === 'gray' && `bg-gray-100 text-gray-900`,
    className,
  )

  return <Component className={styles}>{children}</Component>
}

export {Tag}
